export function getGrossWinnerAmount(winner = {}) {
  const amount = Number(
    winner.gross_winning_amount ??
    winner.grossPrize ??
    winner.winning_amount ??
    winner.prize_amount ??
    winner.amount
  );

  return Number.isFinite(amount) ? amount : 0;
}

export function normalizeWinnerPresentation(winner = {}, drawNumber = "") {
  return {
    name: winner.first_name ?? winner.name ?? "",
    ticket_number: winner.ticket_code ?? winner.ticket_number ?? "",
    gross_winning_amount: getGrossWinnerAmount(winner),
    draw_number: winner.draw_number ?? drawNumber
  };
}
